import { render, staticRenderFns } from "./route-card.vue?vue&type=template&id=08544272&"
import script from "./route-card.vue?vue&type=script&lang=ts&"
export * from "./route-card.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports